import React, { useRef, useState } from "react";
import { logResponse } from "../utils/logger";
import { fetchRequestChangeEmail } from "../api";
import iconAccount from "../assets/img/icon_account.svg";
import SubmitButton from "../components/SubmitButton";

const EmailChange = () => {
  const formRef = useRef();
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setErrors({});
    setErrorMessage("");
    setIsSent(false);

    const formData = new FormData(formRef.current);
    const email = formData.get("email")?.trim();
    const emailConfirm = formData.get("emailConfirm")?.trim();
    const access_token = localStorage.getItem("access_token");

    const newErrors = {};
    if (!email || !isValidEmail(email)) {
      newErrors.email = "有効なメールアドレスを入力してください";
    }
    if (!emailConfirm || !isValidEmail(emailConfirm)) {
      newErrors.emailConfirm = "有効なメールアドレスを再入力してください";
    }
    if (email && emailConfirm && email !== emailConfirm) {
      newErrors.emailConfirm = "メールアドレスが一致しません";
    }
    if (!access_token) {
      setErrorMessage("アクセストークンが見つかりません");
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    try {
      const data = { email };
      const res = await fetchRequestChangeEmail(access_token, data);
      logResponse("token:", access_token);
      logResponse("req:", data);
      logResponse("res:", res);

      if (res?.detail) {
        // detailはエラー応答（メールは送信されていないので成功表示しない）
        if (String(res.detail).includes("email already in use")) {
          setErrorMessage("こちらのメールアドレスは既に登録されています");
        } else {
          setErrorMessage("送信に失敗しました。もう一度お試しください");
        }
      } else {
        setErrorMessage("");
        setIsSent(true);
      }
    } catch (err) {
      console.error("送信エラー:", err);
      setErrorMessage("送信に失敗しました。もう一度お試しください");
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section email-section">
      <h2 className="section-title">
        <i>
          <img src={iconAccount} alt="" />
        </i>
        メールアドレス変更
      </h2>

      <div className="group-wrapper">
        <div className="form-group">
          <p className="explain">
            メールアドレスとパスワードを変更されたい場合は、<br />
            下記より変更をお願い致します。
          </p>

          <form className="box-white" ref={formRef} onSubmit={handleSubmit}>
            <p className="text">
              受信確認が可能な有効化されているメールアドレスを入力してください。
            </p>

            <label>
              <span className="column">変更後のメールアドレス</span>
              <input
                type="text"
                name="email"
                placeholder="example@gmail.com"
                required
              />
              {errors.email && <div className="error">{errors.email}</div>}
            </label>

            <label>
              <span className="column">変更後のメールアドレス（再入力）</span>
              <input
                type="text"
                name="emailConfirm"
                placeholder="example@gmail.com"
                required
              />
              {errors.emailConfirm && <div className="error">{errors.emailConfirm}</div>}
            </label>

            {errorMessage && (
              <div className="error-message">
                <p style={{ color: "red", fontWeight: "bold" }}>{errorMessage}</p>
              </div>
            )}

            {isSent && (
              <div className="info-message" style={{ fontWeight:"bold", marginBottom: "1em", color: "#2e7d32" }}>
                <p>
                  メールアドレス変更リクエストが送信されました。<br />（現時点ではメールアドレスの変更はされていません）<br /><br />
                  入力したメールアドレス宛てに届いた認証用URLをクリック頂くと有効となります。
                </p>
              </div>
            )}

            <div className="btn-green mb0">
              <SubmitButton
                isSubmitting={isSubmitting}
                label="メールアドレスを変更する"
                className="btn-green"
                wrap={false}
              />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EmailChange;
